<template>

      <div class="card flex px-4 py-6 justify-between">
        <div class="self-center">
          <h2 class="mb-1 title lg:title text-left">{{ title }}</h2>
          <h4 class="subtitle lg:subtitle">{{ subTitle }}
            <div class="flex space-x-2">
              <vx-tooltip class="tooltip" v-if="tooltip" :text="tooltip" position="right">
                <vs-icon class="flex justify-center items-center tooltip-icon" icon-pack="speakol" icon="speakol-info"
                round></vs-icon>
              </vx-tooltip>
              <slot name="action"></slot>
            </div>
          </h4>
          <a :id="id" v-if="link" v-on:click="redirect" class="view-button">View</a>
        </div>
        <div class="flex justify-center pb-3">
          <vs-icon v-bind:class="{ card_without_link: !link }" class="flex justify-center items-center card-icon" size="50px" :icon="icon" :color="color || '#2C2C2C'"
                  :bg="backgroundColor || '#FFFFFF'" icon-pack="speakol" round></vs-icon>
        </div>
      </div>
</template>

<script>

export default {

  name: 'speakol-analytics-card',
  props: ['icon', 'color', 'title', 'subTitle', 'backgroundColor', 'tooltip', 'link', 'id'],

  methods: {
    redirect () {
      this.$router.push(this.link)
    }
  }

}
</script>

<style lang="scss" scoped>

.card {
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
}

.link {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  text-decoration-line: underline;
  color: #0092d7;
  position: relative;
  z-index: 999;
  cursor: pointer;
}

.title {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #2c2c2c;
}

.subtitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: rgba(44, 44, 44, 0.7);
  // float: left;
  display: inline-flex;
}

.view-button {
  cursor: pointer;
  color: #0092d7;
  text-decoration: underline;
  display: block;
}

.card-icon {
  position: relative;
  top: 15px;
  font-size: 24px !important;
}

.tooltip {
  margin-top: 5px;
  margin-left: 5px;
}

.tooltip-icon {
  font-size: 12px !important;
}

.card_without_link {
  position: relative;
  top: 5px;
}

.daily-cap-card {
  .speakol-calendar {
    position: relative;
    top: 15px;
  }
}

@media (min-width: 768px) {
  .lg\:card {
    width: 340px;
    height: 106px;
  }

  .lg\:icon {
    height: auto;
  }

  .lg\:card-content {
    height: auto;
  }

  .lg\:subtitle {
    height: auto;
  }
}

@media (max-width: 576px) {
  .daily-cap-card {
    .speakol-calendar {
      position: relative;
      top: 4px;
    }
  }
}

</style>
